import { render, staticRenderFns } from "./cabecalho.vue?vue&type=template&id=644e1790&scoped=true"
import script from "./cabecalho.vue?vue&type=script&lang=js"
export * from "./cabecalho.vue?vue&type=script&lang=js"
import style0 from "./cabecalho.vue?vue&type=style&index=0&id=644e1790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e1790",
  null
  
)

export default component.exports